import {FunctionComponent} from 'react';
import {
    Container,
    Grid,
    Group,
    Paper,
    Stack,
    Text,
    ThemeIcon,
    Title
} from '@mantine/core';
import {Link} from 'react-router-dom';
import {AiOutlineContacts, AiOutlineIdcard, AiOutlineMail, AiOutlineTag, AiOutlineUser} from 'react-icons/ai';
import {MessagesByOwnerChart} from '../components/MessagesByOwnerChart';
import {AliasesByOwnerChart} from '../components/AliasesByOwnerChart';

const adminCards = [
    {
        to: '/administration/messages',
        icon: AiOutlineMail,
        title: 'Messages Overview',
        description: 'View all messages across users',
        color: 'blue'
    },
    {
        to: '/administration/personas',
        icon: AiOutlineUser,
        title: 'Personas Overview',
        description: 'View all personas across users',
        color: 'green'
    },
    {
        to: '/administration/aliases',
        icon: AiOutlineIdcard,
        title: 'Aliases Management',
        description: 'Monitor and manage all aliases',
        color: 'violet'
    },
    {
        to: '/administration/tags',
        icon: AiOutlineTag,
        title: 'Tags Management',
        description: 'Manage and merge tags',
        color: 'orange'
    },
    {
        to: '/administration/contacts',
        icon: AiOutlineContacts,
        title: 'Contacts Overview',
        description: 'View all contacts',
        color: 'cyan'
    }
];

export const IndexPage: FunctionComponent = () => {
    return (
        <Container size="100%" py="xl" style={{ maxWidth: '100%' }}>
            <Stack gap="xl">
                <div>
                    <Title order={1}>Administration</Title>
                    <Text c="dimmed" size="lg">Manage application data and settings</Text>
                </div>

                <Grid gap="xl">
                    <Grid.Col span={4}>
                        <Stack gap="lg">
                            {adminCards.map((card) => {
                                const Icon = card.icon;
                                return (
                                    <Paper
                                        key={card.to}
                                        component={Link}
                                        to={card.to}
                                        p="lg"
                                        withBorder
                                        style={{textDecoration: 'none', color: 'inherit', cursor: 'pointer'}}
                                    >
                                        <Group gap="md">
                                            <ThemeIcon size="xl" variant="light" color={card.color}>
                                                <Icon size={24}/>
                                            </ThemeIcon>
                                            <Stack gap={4} style={{flex: 1}}>
                                                <Title order={4}>{card.title}</Title>
                                                <Text size="sm" c="dimmed">{card.description}</Text>
                                            </Stack>
                                        </Group>
                                    </Paper>
                                );
                            })}
                        </Stack>
                    </Grid.Col>

                    <Grid.Col span={8}>
                        <Stack gap="lg">
                            <MessagesByOwnerChart />
                            <AliasesByOwnerChart />
                        </Stack>
                    </Grid.Col>
                </Grid>
            </Stack>
        </Container>
    );
};
